/**
 * @generated SignedSource<<3efdc6d292858f3684ebe8adc48e6f09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlannerFilterQueryQuery$variables = Record<PropertyKey, never>;
export type PlannerFilterQueryQuery$data = {
  readonly allViews: ReadonlyArray<{
    readonly alias?: string;
    readonly databaseId?: number;
    readonly id?: string;
    readonly peopleFilters?: any;
    readonly projectFilters?: any;
  }>;
  readonly selectedView: {
    readonly alias?: string;
    readonly databaseId?: number;
    readonly isCoerced?: boolean;
    readonly type?: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ViewsProvider_gql">;
};
export type PlannerFilterQueryQuery = {
  response: PlannerFilterQueryQuery$data;
  variables: PlannerFilterQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectFilters",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "peopleFilters",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alias",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/)
  ],
  "type": "VirtualView",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCoerced",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/)
  ],
  "type": "SelectedDatabaseView",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/)
  ],
  "type": "SelectedVirtualView",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlannerFilterQueryQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ViewsProvider_gql"
      },
      {
        "alias": "allViews",
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "availableViews",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "type": "AvailableViewInterface",
            "abstractKey": "__isAvailableViewInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "DatabaseView",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "selectedView",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PlannerFilterQueryQuery",
    "selections": [
      {
        "alias": "allViews",
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "availableViews",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              (v6/*: any*/),
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "type": "AvailableViewInterface",
            "abstractKey": "__isAvailableViewInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userIds",
                "storageKey": null
              }
            ],
            "type": "DatabaseView",
            "abstractKey": null
          },
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "selectedView",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "features_accounts",
        "kind": "LinkedField",
        "name": "features_accounts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "feature_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "170f9b7a6f2ea73bee83c6b48492b299",
    "id": null,
    "metadata": {},
    "name": "PlannerFilterQueryQuery",
    "operationKind": "query",
    "text": "query PlannerFilterQueryQuery {\n  ...ViewsProvider_gql\n  allViews: availableViews {\n    __typename\n    ... on AvailableViewInterface {\n      __isAvailableViewInterface: __typename\n      projectFilters\n      peopleFilters\n    }\n    ... on DatabaseView {\n      id\n      databaseId\n    }\n    ... on VirtualView {\n      id\n      alias\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  selectedView {\n    __typename\n    ... on SelectedDatabaseView {\n      type\n      databaseId\n      isCoerced\n    }\n    ... on SelectedVirtualView {\n      alias\n      isCoerced\n    }\n  }\n}\n\nfragment ViewsProvider_gql on query_root {\n  allViews: availableViews {\n    __typename\n    ... on AvailableViewInterface {\n      __isAvailableViewInterface: __typename\n      name\n      description\n      type\n      projectFilters\n      peopleFilters\n    }\n    ... on DatabaseView {\n      id\n      databaseId\n      userIds\n    }\n    ... on VirtualView {\n      id\n      alias\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  selectedView {\n    __typename\n    ... on SelectedDatabaseView {\n      type\n      databaseId\n      isCoerced\n    }\n    ... on SelectedVirtualView {\n      alias\n      isCoerced\n    }\n  }\n  features_accounts {\n    feature_id\n    enabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "6753454dce41eba8c61a28dbd1cbec61";

export default node;
